import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-push-members-dialog',
  templateUrl: './push-members-dialog.component.html',
  styleUrls: [ './push-members-dialog.component.scss' ]
})
export class PushMembersDialogComponent implements OnInit {

  public members: any[];
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name', 'selected' ];

  constructor (
    public matDialogRef: MatDialogRef<PushMembersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) {
    this.members = this.data;
    this.members.forEach((item)=>{
      item.selected = false;
    })
    this.dataSource = new MatTableDataSource(this.members);
  }

  ngOnInit () {
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
